import { post } from '../../api/api.service';

export interface OrganizationResponse {
  statusCode: number;
  message: string;
  data: any;
}

export const fetchOrganizationApi = async (organizationName: string): Promise<OrganizationResponse> => {
  try {
    const response: OrganizationResponse = await post<OrganizationResponse>(
      `/userdashboard/organization?organizationName=${organizationName}`,
      {}
    );
    return response;
  } catch (error) {
    throw error;
  }
};